// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/chunks/" + ({"200":"insights","328":"postMetrics","1275":"search-insights","3524":"app"}[chunkId] || chunkId) + "-" + {"200":"9887699e","328":"fe1dc7a9","1275":"8234497e","3524":"1a0d6a00","7482":"43f97571"}[chunkId] + ".css";
};